module.exports = __webpack_public_path__ + "img/Banner.db994b09.png";